/* Public catalogue snapshot: chaleursereine.com — 2026-11-01. Prices in EUR. */
window.CATALOGUE = [
  {
    "id": 11263336612177,
    "handle": "veste-chauffante-softshell-femme",
    "title": "Veste chauffante softshell femme",
    "url": "https://chaleursereine.com/products/veste-chauffante-softshell-femme",
    "price": 144.0,
    "compareAtPrice": 180.0,
    "available": true,
    "category": "Veste chauffante",
    "image": "assets/products/veste-chauffante-softshell-femme-01.webp",
    "images": [
      "assets/products/veste-chauffante-softshell-femme-01.webp",
      "assets/products/veste-chauffante-softshell-femme-02.webp",
      "assets/products/veste-chauffante-softshell-femme-03.webp",
      "assets/products/veste-chauffante-softshell-femme-04.webp",
      "assets/products/veste-chauffante-softshell-femme-05.webp",
      "assets/products/veste-chauffante-softshell-femme-06.webp",
      "assets/products/veste-chauffante-softshell-femme-07.webp",
      "assets/products/veste-chauffante-softshell-femme-08.webp",
      "assets/products/veste-chauffante-softshell-femme-09.webp",
      "assets/products/veste-chauffante-softshell-femme-10.webp"
    ],
    "description": "Une veste d'hiver qui chauffe, pour sortir sans appréhension. Vous l'enfilez comme n'importe quelle veste, vous la branchez à une batterie USB 5 V (non incluse), et la chaleur se diffuse dans le dos et les épaules, là où le froid s'installe en premier. Pourquoi on l'a choisie Capuche amovible et col montant : on la garde par grand froid, on l'enlève en ville. Tissu softshell coupe-vent, imperméable et respirant , pour affronter vent et humidité. 6 zones de chaleur : elles réchauffent le dos et les épaules quand le froid devient piquant. Coupe femme , fermeture éclair, poches avant, du M au 5XL. Produit conforme : certifications CE, RoHS et REACH. Composition Matière : polyester et coton Fermeture éclair, capuche amovible, col montant, poches avant Coloris : noir Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Une veste d'hiver qui chauffe, pour sortir sans appréhension.</strong> Vous l'enfilez comme n'importe quelle veste, vous la branchez à une batterie USB 5 V (non incluse), et la chaleur se diffuse dans le dos et les épaules, là où le froid s'installe en premier.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>Capuche amovible</strong> et col montant : on la garde par grand froid, on l'enlève en ville.</li>\n<li>\n<strong>Tissu softshell coupe-vent, imperméable et respirant</strong>, pour affronter vent et humidité.</li>\n<li>\n<strong>6 zones de chaleur</strong> : elles réchauffent le dos et les épaules quand le froid devient piquant.</li>\n<li>\n<strong>Coupe femme</strong>, fermeture éclair, poches avant, du M au 5XL.</li>\n<li>\n<strong>Produit conforme</strong> : certifications CE, RoHS et REACH.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Matière : polyester et coton</li>\n<li>Fermeture éclair, capuche amovible, col montant, poches avant</li>\n<li>Coloris : noir</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "Capuche amovible et col montant : on la garde par grand froid, on l'enlève en ville.",
      "Tissu softshell coupe-vent, imperméable et respirant , pour affronter vent et humidité.",
      "6 zones de chaleur : elles réchauffent le dos et les épaules quand le froid devient piquant.",
      "Coupe femme , fermeture éclair, poches avant, du M au 5XL.",
      "Produit conforme : certifications CE, RoHS et REACH.",
      "Matière : polyester et coton",
      "Fermeture éclair, capuche amovible, col montant, poches avant",
      "Coloris : noir"
    ],
    "sizes": [
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL",
      "5XL"
    ],
    "colors": [
      "Noir"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL",
          "5XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55389586489681,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      },
      {
        "id": 55389586522449,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      },
      {
        "id": 55389586555217,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      },
      {
        "id": 55389586587985,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      },
      {
        "id": 55389586620753,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      },
      {
        "id": 55389586653521,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      },
      {
        "id": 55389586686289,
        "title": "Noir / 5XL",
        "option1": "Noir",
        "option2": "5XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-5XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-femme-01.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263336579409,
    "handle": "veste-chauffante-softshell-homme",
    "title": "Veste chauffante softshell homme",
    "url": "https://chaleursereine.com/products/veste-chauffante-softshell-homme",
    "price": 144.0,
    "compareAtPrice": 180.0,
    "available": true,
    "category": "Veste chauffante",
    "image": "assets/products/veste-chauffante-softshell-homme-01.webp",
    "images": [
      "assets/products/veste-chauffante-softshell-homme-01.webp",
      "assets/products/veste-chauffante-softshell-homme-02.webp",
      "assets/products/veste-chauffante-softshell-homme-03.webp",
      "assets/products/veste-chauffante-softshell-homme-04.webp",
      "assets/products/veste-chauffante-softshell-femme-04.webp",
      "assets/products/veste-chauffante-softshell-femme-06.webp",
      "assets/products/veste-chauffante-softshell-femme-07.webp",
      "assets/products/veste-chauffante-softshell-femme-08.webp",
      "assets/products/veste-chauffante-softshell-femme-09.webp",
      "assets/products/veste-chauffante-softshell-femme-10.webp"
    ],
    "description": "Une veste d'hiver qui chauffe, pour sortir sans appréhension. Vous l'enfilez comme n'importe quelle veste, vous la branchez à une batterie USB 5 V (non incluse), et la chaleur se diffuse dans le dos et les épaules, là où le froid s'installe en premier. Pourquoi on l'a choisie Capuche amovible et col montant : on la garde par grand froid, on l'enlève en ville. Tissu softshell coupe-vent, imperméable et respirant , pour affronter vent et humidité. 6 zones de chaleur : elles réchauffent le dos et les épaules quand le froid devient piquant. Coupe homme classique , fermeture éclair, poches avant, du M au 5XL. Produit conforme : certifications CE, RoHS et REACH. Composition Matière : polyester et coton Fermeture éclair, capuche amovible, col montant, poches avant Coloris : noir Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Une veste d'hiver qui chauffe, pour sortir sans appréhension.</strong> Vous l'enfilez comme n'importe quelle veste, vous la branchez à une batterie USB 5 V (non incluse), et la chaleur se diffuse dans le dos et les épaules, là où le froid s'installe en premier.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>Capuche amovible</strong> et col montant : on la garde par grand froid, on l'enlève en ville.</li>\n<li>\n<strong>Tissu softshell coupe-vent, imperméable et respirant</strong>, pour affronter vent et humidité.</li>\n<li>\n<strong>6 zones de chaleur</strong> : elles réchauffent le dos et les épaules quand le froid devient piquant.</li>\n<li>\n<strong>Coupe homme classique</strong>, fermeture éclair, poches avant, du M au 5XL.</li>\n<li>\n<strong>Produit conforme</strong> : certifications CE, RoHS et REACH.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Matière : polyester et coton</li>\n<li>Fermeture éclair, capuche amovible, col montant, poches avant</li>\n<li>Coloris : noir</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "Capuche amovible et col montant : on la garde par grand froid, on l'enlève en ville.",
      "Tissu softshell coupe-vent, imperméable et respirant , pour affronter vent et humidité.",
      "6 zones de chaleur : elles réchauffent le dos et les épaules quand le froid devient piquant.",
      "Coupe homme classique , fermeture éclair, poches avant, du M au 5XL.",
      "Produit conforme : certifications CE, RoHS et REACH.",
      "Matière : polyester et coton",
      "Fermeture éclair, capuche amovible, col montant, poches avant",
      "Coloris : noir"
    ],
    "sizes": [
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL",
      "5XL"
    ],
    "colors": [
      "Noir"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL",
          "5XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55389586260305,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      },
      {
        "id": 55389586293073,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      },
      {
        "id": 55389586325841,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      },
      {
        "id": 55389586358609,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      },
      {
        "id": 55389586391377,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      },
      {
        "id": 55389586424145,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      },
      {
        "id": 55389586456913,
        "title": "Noir / 5XL",
        "option1": "Noir",
        "option2": "5XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC2-NR-5XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-softshell-homme-01.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263144067409,
    "handle": "ensemble-sous-couche-chauffant-femme",
    "title": "Ensemble sous-couche chauffant femme",
    "url": "https://chaleursereine.com/products/ensemble-sous-couche-chauffant-femme",
    "price": 128.0,
    "compareAtPrice": 160.0,
    "available": true,
    "category": "Sous-couche chauffante",
    "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp",
    "images": [
      "assets/products/ensemble-sous-couche-chauffant-femme-01.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-02.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-03.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-04.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-05.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-06.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-07.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-08.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-09.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp"
    ],
    "description": "La chaleur de la tête aux pieds, cachée sous vos vêtements. Ce haut et ce bas chauffants se portent comme une sous-couche classique, sous un pull, un pantalon ou un manteau. Branchez-les à une batterie USB : la chaleur se diffuse dans le dos, le ventre, les bras et les jambes. Pourquoi on l'a choisi 30 zones chauffantes : 16 sur le haut (dos, ventre, bras), 14 sur le bas (taille et jambes). Invisible : il se porte sous vos vêtements habituels, personne ne le voit. Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné : agréable sur la peau, même éteint. 3 niveaux de chaleur , d'un simple bouton. Moins cher que le haut et le bas achetés séparément. Composition Haut à manches longues + bas long 95 % coton, 5 % élasthanne, intérieur molletonné Alimentation : une batterie USB 5 V par pièce (non incluse) Coupe femme, du S au XXL, en noir ou gris Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>La chaleur de la tête aux pieds, cachée sous vos vêtements.</strong> Ce haut et ce bas chauffants se portent comme une sous-couche classique, sous un pull, un pantalon ou un manteau. Branchez-les à une batterie USB : la chaleur se diffuse dans le dos, le ventre, les bras et les jambes.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>30 zones chauffantes</strong> : 16 sur le haut (dos, ventre, bras), 14 sur le bas (taille et jambes).</li>\n<li>\n<strong>Invisible</strong> : il se porte sous vos vêtements habituels, personne ne le voit.</li>\n<li>\n<strong>Coton doux</strong> (95 % coton, 5 % élasthanne), intérieur molletonné : agréable sur la peau, même éteint.</li>\n<li>\n<strong>3 niveaux de chaleur</strong>, d'un simple bouton.</li>\n<li><strong>Moins cher que le haut et le bas achetés séparément.</strong></li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Haut à manches longues + bas long</li>\n<li>95 % coton, 5 % élasthanne, intérieur molletonné</li>\n<li>Alimentation : une batterie USB 5 V par pièce (non incluse)</li>\n<li>Coupe femme, du S au XXL, en noir ou gris</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "30 zones chauffantes : 16 sur le haut (dos, ventre, bras), 14 sur le bas (taille et jambes).",
      "Invisible : il se porte sous vos vêtements habituels, personne ne le voit.",
      "Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné : agréable sur la peau, même éteint.",
      "3 niveaux de chaleur , d'un simple bouton.",
      "Moins cher que le haut et le bas achetés séparément.",
      "Haut à manches longues + bas long",
      "95 % coton, 5 % élasthanne, intérieur molletonné",
      "Alimentation : une batterie USB 5 V par pièce (non incluse)",
      "Coupe femme, du S au XXL, en noir ou gris"
    ],
    "sizes": [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Gris"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388878635345,
        "title": "Noir / XXS",
        "option1": "Noir",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XXS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878668113,
        "title": "Noir / XS",
        "option1": "Noir",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878700881,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-S",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878733649,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-M",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878766417,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-L",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878799185,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878831953,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XXL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878864721,
        "title": "Gris / XXS",
        "option1": "Gris",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XXS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878897489,
        "title": "Gris / XS",
        "option1": "Gris",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878930257,
        "title": "Gris / S",
        "option1": "Gris",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-S",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878963025,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-M",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878995793,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-L",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388879028561,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388879061329,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XXL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      }
    ],
    "batteryNote": "Batteries non incluses. Une batterie USB 5 V par pièce (haut et bas)."
  },
  {
    "id": 11263144001873,
    "handle": "ensemble-sous-couche-chauffant-homme",
    "title": "Ensemble sous-couche chauffant homme",
    "url": "https://chaleursereine.com/products/ensemble-sous-couche-chauffant-homme",
    "price": 128.0,
    "compareAtPrice": 160.0,
    "available": true,
    "category": "Sous-couche chauffante",
    "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp",
    "images": [
      "assets/products/ensemble-sous-couche-chauffant-femme-01.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-07.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-03.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-04.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-06.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-07.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-08.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-09.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-08.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-09.webp"
    ],
    "description": "La chaleur de la tête aux pieds, cachée sous vos vêtements. Ce haut et ce bas chauffants se portent comme une sous-couche classique, sous un pull, un pantalon ou un manteau. Branchez-les à une batterie USB : la chaleur se diffuse dans le dos, le ventre, les bras et les jambes. Pourquoi on l'a choisi 30 zones chauffantes : 16 sur le haut (dos, ventre, bras), 14 sur le bas (taille et jambes). Invisible : il se porte sous vos vêtements habituels, personne ne le voit. Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné : agréable sur la peau, même éteint. 3 niveaux de chaleur , d'un simple bouton. Moins cher que le haut et le bas achetés séparément. Composition Haut à manches longues + bas long 95 % coton, 5 % élasthanne, intérieur molletonné Alimentation : une batterie USB 5 V par pièce (non incluse) Coupe homme, du S au XXL, en noir ou gris Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>La chaleur de la tête aux pieds, cachée sous vos vêtements.</strong> Ce haut et ce bas chauffants se portent comme une sous-couche classique, sous un pull, un pantalon ou un manteau. Branchez-les à une batterie USB : la chaleur se diffuse dans le dos, le ventre, les bras et les jambes.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>30 zones chauffantes</strong> : 16 sur le haut (dos, ventre, bras), 14 sur le bas (taille et jambes).</li>\n<li>\n<strong>Invisible</strong> : il se porte sous vos vêtements habituels, personne ne le voit.</li>\n<li>\n<strong>Coton doux</strong> (95 % coton, 5 % élasthanne), intérieur molletonné : agréable sur la peau, même éteint.</li>\n<li>\n<strong>3 niveaux de chaleur</strong>, d'un simple bouton.</li>\n<li><strong>Moins cher que le haut et le bas achetés séparément.</strong></li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Haut à manches longues + bas long</li>\n<li>95 % coton, 5 % élasthanne, intérieur molletonné</li>\n<li>Alimentation : une batterie USB 5 V par pièce (non incluse)</li>\n<li>Coupe homme, du S au XXL, en noir ou gris</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "30 zones chauffantes : 16 sur le haut (dos, ventre, bras), 14 sur le bas (taille et jambes).",
      "Invisible : il se porte sous vos vêtements habituels, personne ne le voit.",
      "Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné : agréable sur la peau, même éteint.",
      "3 niveaux de chaleur , d'un simple bouton.",
      "Moins cher que le haut et le bas achetés séparément.",
      "Haut à manches longues + bas long",
      "95 % coton, 5 % élasthanne, intérieur molletonné",
      "Alimentation : une batterie USB 5 V par pièce (non incluse)",
      "Coupe homme, du S au XXL, en noir ou gris"
    ],
    "sizes": [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Gris"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388878012753,
        "title": "Noir / XXS",
        "option1": "Noir",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XXS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878045521,
        "title": "Noir / XS",
        "option1": "Noir",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878078289,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-S",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878111057,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-M",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878143825,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-L",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878176593,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878209361,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-NR-XXL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878242129,
        "title": "Gris / XXS",
        "option1": "Gris",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XXS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878274897,
        "title": "Gris / XS",
        "option1": "Gris",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XS",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878307665,
        "title": "Gris / S",
        "option1": "Gris",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-S",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878340433,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-M",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878373201,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-L",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878405969,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388878438737,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCE-GR-XXL",
        "price": 128.0,
        "compareAtPrice": 160.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-01.webp"
      }
    ],
    "batteryNote": "Batteries non incluses. Une batterie USB 5 V par pièce (haut et bas)."
  },
  {
    "id": 11263143936337,
    "handle": "bas-sous-couche-chauffant-femme",
    "title": "Sous-couche bas chauffant femme",
    "url": "https://chaleursereine.com/products/bas-sous-couche-chauffant-femme",
    "price": 71.2,
    "compareAtPrice": 89.0,
    "available": true,
    "category": "Sous-couche chauffante",
    "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp",
    "images": [
      "assets/products/bas-sous-couche-chauffant-femme-01.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-03.webp",
      "assets/products/bas-sous-couche-chauffant-femme-03.webp",
      "assets/products/bas-sous-couche-chauffant-femme-04.webp",
      "assets/products/bas-sous-couche-chauffant-femme-05.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp",
      "assets/products/bas-sous-couche-chauffant-femme-07.webp",
      "assets/products/bas-sous-couche-chauffant-femme-08.webp"
    ],
    "description": "Fini les jambes glacées. Ce bas chauffant se porte comme un collant épais, sous un pantalon. Branchez-le à une batterie USB : la chaleur se diffuse sur la taille et le long des jambes. Pourquoi on l'a choisi 14 zones chauffantes : la taille et les jambes. Invisible sous un pantalon. Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné. 3 niveaux de chaleur , d'un simple bouton. Composition Bas long, taille élastique 95 % coton, 5 % élasthanne, intérieur molletonné Alimentation : batterie USB 5 V (non incluse) Coupe femme, du S au XXL, en noir ou gris Envie d'avoir chaud aussi au dos ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.",
    "descriptionHtml": "<p><strong>Fini les jambes glacées.</strong> Ce bas chauffant se porte comme un collant épais, sous un pantalon. Branchez-le à une batterie USB : la chaleur se diffuse sur la taille et le long des jambes.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>14 zones chauffantes</strong> : la taille et les jambes.</li>\n<li>\n<strong>Invisible</strong> sous un pantalon.</li>\n<li>\n<strong>Coton doux</strong> (95 % coton, 5 % élasthanne), intérieur molletonné.</li>\n<li>\n<strong>3 niveaux de chaleur</strong>, d'un simple bouton.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Bas long, taille élastique</li>\n<li>95 % coton, 5 % élasthanne, intérieur molletonné</li>\n<li>Alimentation : batterie USB 5 V (non incluse)</li>\n<li>Coupe femme, du S au XXL, en noir ou gris</li>\n</ul>\n<p>Envie d'avoir chaud aussi au dos ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.</p>",
    "features": [
      "14 zones chauffantes : la taille et les jambes.",
      "Invisible sous un pantalon.",
      "Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné.",
      "3 niveaux de chaleur , d'un simple bouton.",
      "Bas long, taille élastique",
      "95 % coton, 5 % élasthanne, intérieur molletonné",
      "Alimentation : batterie USB 5 V (non incluse)",
      "Coupe femme, du S au XXL, en noir ou gris"
    ],
    "sizes": [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Gris"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388877357393,
        "title": "Noir / XXS",
        "option1": "Noir",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877390161,
        "title": "Noir / XS",
        "option1": "Noir",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877422929,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877455697,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877488465,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877521233,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877554001,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877586769,
        "title": "Gris / XXS",
        "option1": "Gris",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877619537,
        "title": "Gris / XS",
        "option1": "Gris",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877652305,
        "title": "Gris / S",
        "option1": "Gris",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877685073,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877717841,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877750609,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      },
      {
        "id": 55388877783377,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/bas-sous-couche-chauffant-femme-01.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143838033,
    "handle": "bas-sous-couche-chauffant-homme",
    "title": "Sous-couche bas chauffant homme",
    "url": "https://chaleursereine.com/products/bas-sous-couche-chauffant-homme",
    "price": 71.2,
    "compareAtPrice": 89.0,
    "available": true,
    "category": "Sous-couche chauffante",
    "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp",
    "images": [
      "assets/products/ensemble-sous-couche-chauffant-homme-06.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-03.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-07.webp",
      "assets/products/bas-sous-couche-chauffant-homme-04.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-08.webp",
      "assets/products/ensemble-sous-couche-chauffant-homme-09.webp",
      "assets/products/bas-sous-couche-chauffant-femme-07.webp",
      "assets/products/bas-sous-couche-chauffant-femme-08.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp"
    ],
    "description": "Fini les jambes glacées. Ce bas chauffant se porte comme un collant épais, sous un pantalon. Branchez-le à une batterie USB : la chaleur se diffuse sur la taille et le long des jambes. Pourquoi on l'a choisi 14 zones chauffantes : la taille et les jambes. Invisible sous un pantalon. Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné. 3 niveaux de chaleur , d'un simple bouton. Composition Bas long, taille élastique 95 % coton, 5 % élasthanne, intérieur molletonné Alimentation : batterie USB 5 V (non incluse) Coupe homme, du S au XXL, en noir ou gris Envie d'avoir chaud aussi au dos ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.",
    "descriptionHtml": "<p><strong>Fini les jambes glacées.</strong> Ce bas chauffant se porte comme un collant épais, sous un pantalon. Branchez-le à une batterie USB : la chaleur se diffuse sur la taille et le long des jambes.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>14 zones chauffantes</strong> : la taille et les jambes.</li>\n<li>\n<strong>Invisible</strong> sous un pantalon.</li>\n<li>\n<strong>Coton doux</strong> (95 % coton, 5 % élasthanne), intérieur molletonné.</li>\n<li>\n<strong>3 niveaux de chaleur</strong>, d'un simple bouton.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Bas long, taille élastique</li>\n<li>95 % coton, 5 % élasthanne, intérieur molletonné</li>\n<li>Alimentation : batterie USB 5 V (non incluse)</li>\n<li>Coupe homme, du S au XXL, en noir ou gris</li>\n</ul>\n<p>Envie d'avoir chaud aussi au dos ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.</p>",
    "features": [
      "14 zones chauffantes : la taille et les jambes.",
      "Invisible sous un pantalon.",
      "Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné.",
      "3 niveaux de chaleur , d'un simple bouton.",
      "Bas long, taille élastique",
      "95 % coton, 5 % élasthanne, intérieur molletonné",
      "Alimentation : batterie USB 5 V (non incluse)",
      "Coupe homme, du S au XXL, en noir ou gris"
    ],
    "sizes": [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Gris"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388876636497,
        "title": "Noir / XXS",
        "option1": "Noir",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876669265,
        "title": "Noir / XS",
        "option1": "Noir",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876702033,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876734801,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876767569,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876800337,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876833105,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-NR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876865873,
        "title": "Gris / XXS",
        "option1": "Gris",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876898641,
        "title": "Gris / XS",
        "option1": "Gris",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876931409,
        "title": "Gris / S",
        "option1": "Gris",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876964177,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388876996945,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388877029713,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      },
      {
        "id": 55388877062481,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCB-GR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-homme-06.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143772497,
    "handle": "haut-sous-couche-chauffant-femme",
    "title": "T-shirt chauffant femme manches longues",
    "url": "https://chaleursereine.com/products/haut-sous-couche-chauffant-femme",
    "price": 71.2,
    "compareAtPrice": 89.0,
    "available": true,
    "category": "Sous-couche chauffante",
    "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp",
    "images": [
      "assets/products/ensemble-sous-couche-chauffant-femme-02.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-03.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-05.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-06.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-04.webp",
      "assets/products/haut-sous-couche-chauffant-femme-06.webp",
      "assets/products/haut-sous-couche-chauffant-femme-07.webp",
      "assets/products/haut-sous-couche-chauffant-femme-08.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp"
    ],
    "description": "Un haut chaud comme une bouillotte, fin comme un t-shirt. Ce haut chauffant à manches longues se porte directement sur la peau, sous un pull ou une chemise. Branchez-le à une batterie USB : la chaleur se diffuse dans le dos, le ventre et les bras. Pourquoi on l'a choisi 16 zones chauffantes : le dos, le ventre et les bras. Invisible sous un pull, une chemise ou un manteau. Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné. 3 niveaux de chaleur , d'un simple bouton. Composition Haut à manches longues, col rond 95 % coton, 5 % élasthanne, intérieur molletonné Alimentation : batterie USB 5 V (non incluse) Coupe femme, du S au XXL, en noir ou gris Envie d'avoir chaud aussi aux jambes ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.",
    "descriptionHtml": "<p><strong>Un haut chaud comme une bouillotte, fin comme un t-shirt.</strong> Ce haut chauffant à manches longues se porte directement sur la peau, sous un pull ou une chemise. Branchez-le à une batterie USB : la chaleur se diffuse dans le dos, le ventre et les bras.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>16 zones chauffantes</strong> : le dos, le ventre et les bras.</li>\n<li>\n<strong>Invisible</strong> sous un pull, une chemise ou un manteau.</li>\n<li>\n<strong>Coton doux</strong> (95 % coton, 5 % élasthanne), intérieur molletonné.</li>\n<li>\n<strong>3 niveaux de chaleur</strong>, d'un simple bouton.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Haut à manches longues, col rond</li>\n<li>95 % coton, 5 % élasthanne, intérieur molletonné</li>\n<li>Alimentation : batterie USB 5 V (non incluse)</li>\n<li>Coupe femme, du S au XXL, en noir ou gris</li>\n</ul>\n<p>Envie d'avoir chaud aussi aux jambes ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.</p>",
    "features": [
      "16 zones chauffantes : le dos, le ventre et les bras.",
      "Invisible sous un pull, une chemise ou un manteau.",
      "Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné.",
      "3 niveaux de chaleur , d'un simple bouton.",
      "Haut à manches longues, col rond",
      "95 % coton, 5 % élasthanne, intérieur molletonné",
      "Alimentation : batterie USB 5 V (non incluse)",
      "Coupe femme, du S au XXL, en noir ou gris"
    ],
    "sizes": [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Gris"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388876013905,
        "title": "Noir / XXS",
        "option1": "Noir",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876046673,
        "title": "Noir / XS",
        "option1": "Noir",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876079441,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876112209,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876144977,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876177745,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876210513,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876243281,
        "title": "Gris / XXS",
        "option1": "Gris",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876276049,
        "title": "Gris / XS",
        "option1": "Gris",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876308817,
        "title": "Gris / S",
        "option1": "Gris",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876341585,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876374353,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876407121,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      },
      {
        "id": 55388876439889,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/ensemble-sous-couche-chauffant-femme-02.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143706961,
    "handle": "haut-sous-couche-chauffant-homme",
    "title": "T-shirt chauffant homme manches longues",
    "url": "https://chaleursereine.com/products/haut-sous-couche-chauffant-homme",
    "price": 71.2,
    "compareAtPrice": 89.0,
    "available": true,
    "category": "Sous-couche chauffante",
    "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp",
    "images": [
      "assets/products/haut-sous-couche-chauffant-homme-01.webp",
      "assets/products/haut-sous-couche-chauffant-homme-02.webp",
      "assets/products/haut-sous-couche-chauffant-homme-03.webp",
      "assets/products/haut-sous-couche-chauffant-homme-04.webp",
      "assets/products/haut-sous-couche-chauffant-homme-05.webp",
      "assets/products/haut-sous-couche-chauffant-femme-06.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp",
      "assets/products/haut-sous-couche-chauffant-femme-08.webp",
      "assets/products/haut-sous-couche-chauffant-femme-07.webp"
    ],
    "description": "Un haut chaud comme une bouillotte, fin comme un t-shirt. Ce haut chauffant à manches longues se porte directement sur la peau, sous un pull ou une chemise. Branchez-le à une batterie USB : la chaleur se diffuse dans le dos, le ventre et les bras. Pourquoi on l'a choisi 16 zones chauffantes : le dos, le ventre et les bras. Invisible sous un pull, une chemise ou un manteau. Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné. 3 niveaux de chaleur , d'un simple bouton. Composition Haut à manches longues, col rond 95 % coton, 5 % élasthanne, intérieur molletonné Alimentation : batterie USB 5 V (non incluse) Coupe homme, du S au XXL, en noir ou gris Envie d'avoir chaud aussi aux jambes ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.",
    "descriptionHtml": "<p><strong>Un haut chaud comme une bouillotte, fin comme un t-shirt.</strong> Ce haut chauffant à manches longues se porte directement sur la peau, sous un pull ou une chemise. Branchez-le à une batterie USB : la chaleur se diffuse dans le dos, le ventre et les bras.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>16 zones chauffantes</strong> : le dos, le ventre et les bras.</li>\n<li>\n<strong>Invisible</strong> sous un pull, une chemise ou un manteau.</li>\n<li>\n<strong>Coton doux</strong> (95 % coton, 5 % élasthanne), intérieur molletonné.</li>\n<li>\n<strong>3 niveaux de chaleur</strong>, d'un simple bouton.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Haut à manches longues, col rond</li>\n<li>95 % coton, 5 % élasthanne, intérieur molletonné</li>\n<li>Alimentation : batterie USB 5 V (non incluse)</li>\n<li>Coupe homme, du S au XXL, en noir ou gris</li>\n</ul>\n<p>Envie d'avoir chaud aussi aux jambes ? L'ensemble haut et bas revient moins cher que les deux pièces achetées séparément.</p>",
    "features": [
      "16 zones chauffantes : le dos, le ventre et les bras.",
      "Invisible sous un pull, une chemise ou un manteau.",
      "Coton doux (95 % coton, 5 % élasthanne), intérieur molletonné.",
      "3 niveaux de chaleur , d'un simple bouton.",
      "Haut à manches longues, col rond",
      "95 % coton, 5 % élasthanne, intérieur molletonné",
      "Alimentation : batterie USB 5 V (non incluse)",
      "Coupe homme, du S au XXL, en noir ou gris"
    ],
    "sizes": [
      "XXS",
      "XS",
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Gris"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "XXS",
          "XS",
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388875391313,
        "title": "Noir / XXS",
        "option1": "Noir",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875424081,
        "title": "Noir / XS",
        "option1": "Noir",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875456849,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875489617,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875522385,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875555153,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875587921,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-NR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875620689,
        "title": "Gris / XXS",
        "option1": "Gris",
        "option2": "XXS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XXS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875653457,
        "title": "Gris / XS",
        "option1": "Gris",
        "option2": "XS",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XS",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875686225,
        "title": "Gris / S",
        "option1": "Gris",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-S",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875718993,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-M",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875751761,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-L",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875784529,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      },
      {
        "id": 55388875817297,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-SCH-GR-XXL",
        "price": 71.2,
        "compareAtPrice": 89.0,
        "image": "assets/products/haut-sous-couche-chauffant-homme-01.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143608657,
    "handle": "doudoune-chauffante-longue-femme",
    "title": "Doudoune chauffante longue femme",
    "url": "https://chaleursereine.com/products/doudoune-chauffante-longue-femme",
    "price": 144.0,
    "compareAtPrice": 180.0,
    "available": true,
    "category": "Doudoune chauffante",
    "image": "assets/products/doudoune-chauffante-longue-femme-01.webp",
    "images": [
      "assets/products/doudoune-chauffante-longue-femme-01.webp",
      "assets/products/doudoune-chauffante-longue-femme-02.webp",
      "assets/products/doudoune-chauffante-longue-femme-03.webp",
      "assets/products/doudoune-chauffante-longue-femme-04.webp",
      "assets/products/doudoune-chauffante-longue-femme-05.webp",
      "assets/products/doudoune-chauffante-longue-femme-06.webp",
      "assets/products/doudoune-chauffante-longue-femme-07.webp",
      "assets/products/doudoune-chauffante-longue-femme-08.webp",
      "assets/products/doudoune-chauffante-longue-femme-09.webp",
      "assets/products/doudoune-chauffante-longue-femme-10.webp",
      "assets/products/doudoune-chauffante-longue-femme-11.webp",
      "assets/products/doudoune-chauffante-longue-femme-12.webp"
    ],
    "description": "Une doudoune longue qui produit sa propre chaleur. Vous l'enfilez, vous la branchez à une batterie USB (non incluse), et la chaleur se diffuse dans le buste et le dos. Une seule veste, au lieu de trois couches de pulls. Pourquoi on l'a choisie 6 zones chauffantes , alimentées par batterie USB : la chaleur là où le froid s'installe en premier. Coupe longue , qui descend sur les hanches, là où le froid passe sous les vestes courtes. Chaude et épaisse : elle tient déjà chaud éteinte, c'est d'abord une vraie veste d'hiver. Tissu imperméable, coupe-vent et à séchage rapide , avec col montant. Coupe femme , du M au XXL. Composition Tissu extérieur : polyester Composition : polyester et coton Col montant, manches longues, fermeture éclair Coloris : noir, blanc, gris ou bleu Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Une doudoune longue qui produit sa propre chaleur.</strong> Vous l'enfilez, vous la branchez à une batterie USB (non incluse), et la chaleur se diffuse dans le buste et le dos. Une seule veste, au lieu de trois couches de pulls.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>6 zones chauffantes</strong>, alimentées par batterie USB : la chaleur là où le froid s'installe en premier.</li>\n<li>\n<strong>Coupe longue</strong>, qui descend sur les hanches, là où le froid passe sous les vestes courtes.</li>\n<li>\n<strong>Chaude et épaisse</strong> : elle tient déjà chaud éteinte, c'est d'abord une vraie veste d'hiver.</li>\n<li>\n<strong>Tissu imperméable, coupe-vent et à séchage rapide</strong>, avec col montant.</li>\n<li>\n<strong>Coupe femme</strong>, du M au XXL.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Tissu extérieur : polyester</li>\n<li>Composition : polyester et coton</li>\n<li>Col montant, manches longues, fermeture éclair</li>\n<li>Coloris : noir, blanc, gris ou bleu</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "6 zones chauffantes , alimentées par batterie USB : la chaleur là où le froid s'installe en premier.",
      "Coupe longue , qui descend sur les hanches, là où le froid passe sous les vestes courtes.",
      "Chaude et épaisse : elle tient déjà chaud éteinte, c'est d'abord une vraie veste d'hiver.",
      "Tissu imperméable, coupe-vent et à séchage rapide , avec col montant.",
      "Coupe femme , du M au XXL.",
      "Tissu extérieur : polyester",
      "Composition : polyester et coton",
      "Col montant, manches longues, fermeture éclair",
      "Coloris : noir, blanc, gris ou bleu"
    ],
    "sizes": [
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL"
    ],
    "colors": [
      "Noir",
      "Blanc",
      "Gris",
      "Bleu"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Blanc",
          "Gris",
          "Bleu"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388874244433,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-01.webp"
      },
      {
        "id": 55388874277201,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-01.webp"
      },
      {
        "id": 55388874309969,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-01.webp"
      },
      {
        "id": 55388874342737,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-01.webp"
      },
      {
        "id": 55388874375505,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-01.webp"
      },
      {
        "id": 55388874408273,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-01.webp"
      },
      {
        "id": 55388874441041,
        "title": "Blanc / M",
        "option1": "Blanc",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-10.webp"
      },
      {
        "id": 55388874473809,
        "title": "Blanc / L",
        "option1": "Blanc",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-10.webp"
      },
      {
        "id": 55388874506577,
        "title": "Blanc / XL",
        "option1": "Blanc",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-10.webp"
      },
      {
        "id": 55388874539345,
        "title": "Blanc / XXL",
        "option1": "Blanc",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-10.webp"
      },
      {
        "id": 55388874572113,
        "title": "Blanc / 3XL",
        "option1": "Blanc",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-10.webp"
      },
      {
        "id": 55388874604881,
        "title": "Blanc / 4XL",
        "option1": "Blanc",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-10.webp"
      },
      {
        "id": 55388874637649,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-08.webp"
      },
      {
        "id": 55388874670417,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-08.webp"
      },
      {
        "id": 55388874703185,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-08.webp"
      },
      {
        "id": 55388874735953,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-08.webp"
      },
      {
        "id": 55388874768721,
        "title": "Gris / 3XL",
        "option1": "Gris",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-08.webp"
      },
      {
        "id": 55388874801489,
        "title": "Gris / 4XL",
        "option1": "Gris",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-08.webp"
      },
      {
        "id": 55388874834257,
        "title": "Bleu / M",
        "option1": "Bleu",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-09.webp"
      },
      {
        "id": 55388874867025,
        "title": "Bleu / L",
        "option1": "Bleu",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-09.webp"
      },
      {
        "id": 55388874899793,
        "title": "Bleu / XL",
        "option1": "Bleu",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-09.webp"
      },
      {
        "id": 55388874932561,
        "title": "Bleu / XXL",
        "option1": "Bleu",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-09.webp"
      },
      {
        "id": 55388874965329,
        "title": "Bleu / 3XL",
        "option1": "Bleu",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-09.webp"
      },
      {
        "id": 55388874998097,
        "title": "Bleu / 4XL",
        "option1": "Bleu",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-femme-09.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143510353,
    "handle": "doudoune-chauffante-longue-homme",
    "title": "Doudoune chauffante longue homme",
    "url": "https://chaleursereine.com/products/doudoune-chauffante-longue-homme",
    "price": 144.0,
    "compareAtPrice": 180.0,
    "available": true,
    "category": "Doudoune chauffante",
    "image": "assets/products/doudoune-chauffante-longue-homme-01.webp",
    "images": [
      "assets/products/doudoune-chauffante-longue-homme-01.webp",
      "assets/products/doudoune-chauffante-longue-homme-02.webp",
      "assets/products/doudoune-chauffante-longue-homme-03.webp",
      "assets/products/doudoune-chauffante-longue-femme-06.webp",
      "assets/products/doudoune-chauffante-longue-femme-04.webp",
      "assets/products/doudoune-chauffante-longue-femme-05.webp",
      "assets/products/doudoune-chauffante-longue-femme-07.webp",
      "assets/products/doudoune-chauffante-longue-homme-08.webp",
      "assets/products/doudoune-chauffante-longue-homme-09.webp",
      "assets/products/doudoune-chauffante-longue-homme-10.webp",
      "assets/products/doudoune-chauffante-longue-femme-11.webp",
      "assets/products/doudoune-chauffante-longue-femme-12.webp"
    ],
    "description": "Une doudoune longue qui produit sa propre chaleur. Vous l'enfilez, vous la branchez à une batterie USB (non incluse), et la chaleur se diffuse dans le buste et le dos. Une seule veste, au lieu de trois couches de pulls. Pourquoi on l'a choisie 6 zones chauffantes , alimentées par batterie USB : la chaleur là où le froid s'installe en premier. Coupe longue , qui descend sur les hanches, là où le froid passe sous les vestes courtes. Chaude et épaisse : elle tient déjà chaud éteinte, c'est d'abord une vraie veste d'hiver. Tissu imperméable, coupe-vent et à séchage rapide , avec col montant. Coupe homme , du M au XXL. Composition Tissu extérieur : polyester Composition : polyester et coton Col montant, manches longues, fermeture éclair Coloris : noir, blanc, gris ou bleu Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Une doudoune longue qui produit sa propre chaleur.</strong> Vous l'enfilez, vous la branchez à une batterie USB (non incluse), et la chaleur se diffuse dans le buste et le dos. Une seule veste, au lieu de trois couches de pulls.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>6 zones chauffantes</strong>, alimentées par batterie USB : la chaleur là où le froid s'installe en premier.</li>\n<li>\n<strong>Coupe longue</strong>, qui descend sur les hanches, là où le froid passe sous les vestes courtes.</li>\n<li>\n<strong>Chaude et épaisse</strong> : elle tient déjà chaud éteinte, c'est d'abord une vraie veste d'hiver.</li>\n<li>\n<strong>Tissu imperméable, coupe-vent et à séchage rapide</strong>, avec col montant.</li>\n<li>\n<strong>Coupe homme</strong>, du M au XXL.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Tissu extérieur : polyester</li>\n<li>Composition : polyester et coton</li>\n<li>Col montant, manches longues, fermeture éclair</li>\n<li>Coloris : noir, blanc, gris ou bleu</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "6 zones chauffantes , alimentées par batterie USB : la chaleur là où le froid s'installe en premier.",
      "Coupe longue , qui descend sur les hanches, là où le froid passe sous les vestes courtes.",
      "Chaude et épaisse : elle tient déjà chaud éteinte, c'est d'abord une vraie veste d'hiver.",
      "Tissu imperméable, coupe-vent et à séchage rapide , avec col montant.",
      "Coupe homme , du M au XXL.",
      "Tissu extérieur : polyester",
      "Composition : polyester et coton",
      "Col montant, manches longues, fermeture éclair",
      "Coloris : noir, blanc, gris ou bleu"
    ],
    "sizes": [
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL"
    ],
    "colors": [
      "Noir",
      "Blanc",
      "Gris",
      "Bleu"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Blanc",
          "Gris",
          "Bleu"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388873294161,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-01.webp"
      },
      {
        "id": 55388873326929,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-01.webp"
      },
      {
        "id": 55388873359697,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-01.webp"
      },
      {
        "id": 55388873392465,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-01.webp"
      },
      {
        "id": 55388873425233,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-01.webp"
      },
      {
        "id": 55388873458001,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-NR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-01.webp"
      },
      {
        "id": 55388873490769,
        "title": "Blanc / M",
        "option1": "Blanc",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-10.webp"
      },
      {
        "id": 55388873523537,
        "title": "Blanc / L",
        "option1": "Blanc",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-10.webp"
      },
      {
        "id": 55388873556305,
        "title": "Blanc / XL",
        "option1": "Blanc",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-10.webp"
      },
      {
        "id": 55388873589073,
        "title": "Blanc / XXL",
        "option1": "Blanc",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-10.webp"
      },
      {
        "id": 55388873621841,
        "title": "Blanc / 3XL",
        "option1": "Blanc",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-10.webp"
      },
      {
        "id": 55388873654609,
        "title": "Blanc / 4XL",
        "option1": "Blanc",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BC-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-10.webp"
      },
      {
        "id": 55388873687377,
        "title": "Gris / M",
        "option1": "Gris",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-08.webp"
      },
      {
        "id": 55388873720145,
        "title": "Gris / L",
        "option1": "Gris",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-08.webp"
      },
      {
        "id": 55388873752913,
        "title": "Gris / XL",
        "option1": "Gris",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-08.webp"
      },
      {
        "id": 55388873785681,
        "title": "Gris / XXL",
        "option1": "Gris",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-08.webp"
      },
      {
        "id": 55388873818449,
        "title": "Gris / 3XL",
        "option1": "Gris",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-08.webp"
      },
      {
        "id": 55388873851217,
        "title": "Gris / 4XL",
        "option1": "Gris",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-GR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-08.webp"
      },
      {
        "id": 55388873883985,
        "title": "Bleu / M",
        "option1": "Bleu",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-09.webp"
      },
      {
        "id": 55388873916753,
        "title": "Bleu / L",
        "option1": "Bleu",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-09.webp"
      },
      {
        "id": 55388873949521,
        "title": "Bleu / XL",
        "option1": "Bleu",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-09.webp"
      },
      {
        "id": 55388873982289,
        "title": "Bleu / XXL",
        "option1": "Bleu",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-09.webp"
      },
      {
        "id": 55388874015057,
        "title": "Bleu / 3XL",
        "option1": "Bleu",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-09.webp"
      },
      {
        "id": 55388874047825,
        "title": "Bleu / 4XL",
        "option1": "Bleu",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-DD1-BL-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/doudoune-chauffante-longue-homme-09.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143444817,
    "handle": "veste-chauffante-a-capuche-femme",
    "title": "Veste chauffante à capuche femme",
    "url": "https://chaleursereine.com/products/veste-chauffante-a-capuche-femme",
    "price": 144.0,
    "compareAtPrice": 180.0,
    "available": true,
    "category": "Veste chauffante",
    "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp",
    "images": [
      "assets/products/veste-chauffante-a-capuche-femme-01.webp",
      "assets/products/veste-chauffante-a-capuche-femme-02.webp",
      "assets/products/veste-chauffante-a-capuche-femme-03.webp",
      "assets/products/veste-chauffante-a-capuche-femme-04.webp",
      "assets/products/veste-chauffante-a-capuche-femme-05.webp",
      "assets/products/veste-chauffante-a-capuche-femme-06.webp",
      "assets/products/veste-chauffante-a-capuche-femme-07.webp",
      "assets/products/veste-chauffante-a-capuche-femme-08.webp",
      "assets/products/veste-chauffante-a-capuche-femme-09.webp",
      "assets/products/veste-chauffante-a-capuche-femme-10.webp",
      "assets/products/veste-chauffante-a-capuche-femme-11.webp",
      "assets/products/veste-chauffante-a-capuche-femme-12.webp",
      "assets/products/veste-chauffante-a-capuche-femme-13.webp",
      "assets/products/veste-chauffante-a-capuche-femme-14.webp"
    ],
    "description": "Une veste qui produit sa propre chaleur, là où vous en avez besoin. Vous l'enfilez comme n'importe quelle veste d'hiver, vous appuyez sur le bouton, et la chaleur se diffuse doucement dans le dos, sur les épaules, à la nuque et au ventre. Pourquoi on l'a choisie 6 zones de chaleur : nuque, épaules, dos et ventre. Les endroits où le froid s'installe en premier. Un seul bouton , sur la poitrine : pas d'application, pas de télécommande. Doublure intérieure réfléchissante qui garde la chaleur contre vous au lieu de la laisser s'échapper. Tissu coupe-vent et imperméable , avec capuche et col montant, pour sortir sans appréhension. Chaude même éteinte : c'est d'abord une vraie veste matelassée d'hiver. Comment ça marche La veste fonctionne en basse tension, avec une batterie externe USB (non incluse) qui se branche à l'intérieur. Un appui sur le bouton suffit pour l'allumer et régler la chaleur. Composition Tissu extérieur : 100 % polyester Rembourrage : coton Doublure : polyester, avec film réfléchissant Fermeture éclair, capuche, col montant, poches Coupe femme, du S au XXL Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Une veste qui produit sa propre chaleur, là où vous en avez besoin.</strong> Vous l'enfilez comme n'importe quelle veste d'hiver, vous appuyez sur le bouton, et la chaleur se diffuse doucement dans le dos, sur les épaules, à la nuque et au ventre.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>6 zones de chaleur</strong> : nuque, épaules, dos et ventre. Les endroits où le froid s'installe en premier.</li>\n<li>\n<strong>Un seul bouton</strong>, sur la poitrine : pas d'application, pas de télécommande.</li>\n<li>\n<strong>Doublure intérieure réfléchissante</strong> qui garde la chaleur contre vous au lieu de la laisser s'échapper.</li>\n<li>\n<strong>Tissu coupe-vent et imperméable</strong>, avec capuche et col montant, pour sortir sans appréhension.</li>\n<li>\n<strong>Chaude même éteinte</strong> : c'est d'abord une vraie veste matelassée d'hiver.</li>\n</ul>\n<h3>Comment ça marche</h3>\n<p>La veste fonctionne en basse tension, avec une batterie externe USB (non incluse) qui se branche à l'intérieur. Un appui sur le bouton suffit pour l'allumer et régler la chaleur.</p>\n<h3>Composition</h3>\n<ul>\n<li>Tissu extérieur : 100 % polyester</li>\n<li>Rembourrage : coton</li>\n<li>Doublure : polyester, avec film réfléchissant</li>\n<li>Fermeture éclair, capuche, col montant, poches</li>\n<li>Coupe femme, du S au XXL</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "6 zones de chaleur : nuque, épaules, dos et ventre. Les endroits où le froid s'installe en premier.",
      "Un seul bouton , sur la poitrine : pas d'application, pas de télécommande.",
      "Doublure intérieure réfléchissante qui garde la chaleur contre vous au lieu de la laisser s'échapper.",
      "Tissu coupe-vent et imperméable , avec capuche et col montant, pour sortir sans appréhension.",
      "Chaude même éteinte : c'est d'abord une vraie veste matelassée d'hiver.",
      "Tissu extérieur : 100 % polyester",
      "Rembourrage : coton",
      "Doublure : polyester, avec film réfléchissant",
      "Fermeture éclair, capuche, col montant, poches",
      "Coupe femme, du S au XXL"
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL"
    ],
    "colors": [
      "Noir",
      "Bleu marine",
      "Rouge"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Bleu marine",
          "Rouge"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "S",
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388872278353,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-S",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872311121,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872343889,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872376657,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872409425,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872442193,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872474961,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-01.webp"
      },
      {
        "id": 55388872507729,
        "title": "Bleu marine / S",
        "option1": "Bleu marine",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-S",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872540497,
        "title": "Bleu marine / M",
        "option1": "Bleu marine",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872573265,
        "title": "Bleu marine / L",
        "option1": "Bleu marine",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872606033,
        "title": "Bleu marine / XL",
        "option1": "Bleu marine",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872638801,
        "title": "Bleu marine / XXL",
        "option1": "Bleu marine",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872671569,
        "title": "Bleu marine / 3XL",
        "option1": "Bleu marine",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872704337,
        "title": "Bleu marine / 4XL",
        "option1": "Bleu marine",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388872737105,
        "title": "Rouge / S",
        "option1": "Rouge",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-S",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872769873,
        "title": "Rouge / M",
        "option1": "Rouge",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872802641,
        "title": "Rouge / L",
        "option1": "Rouge",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872835409,
        "title": "Rouge / XL",
        "option1": "Rouge",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872868177,
        "title": "Rouge / XXL",
        "option1": "Rouge",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872900945,
        "title": "Rouge / 3XL",
        "option1": "Rouge",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872933713,
        "title": "Rouge / 4XL",
        "option1": "Rouge",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11263143379281,
    "handle": "veste-chauffante-a-capuche-homme",
    "title": "Veste chauffante à capuche homme",
    "url": "https://chaleursereine.com/products/veste-chauffante-a-capuche-homme",
    "price": 144.0,
    "compareAtPrice": 180.0,
    "available": true,
    "category": "Veste chauffante",
    "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp",
    "images": [
      "assets/products/veste-chauffante-a-capuche-homme-01.webp",
      "assets/products/veste-chauffante-a-capuche-homme-02.webp",
      "assets/products/veste-chauffante-a-capuche-homme-03.webp",
      "assets/products/veste-chauffante-a-capuche-homme-04.webp",
      "assets/products/veste-chauffante-a-capuche-femme-05.webp",
      "assets/products/veste-chauffante-a-capuche-femme-06.webp",
      "assets/products/veste-chauffante-a-capuche-femme-07.webp",
      "assets/products/veste-chauffante-a-capuche-femme-08.webp",
      "assets/products/veste-chauffante-a-capuche-femme-09.webp",
      "assets/products/veste-chauffante-a-capuche-femme-10.webp",
      "assets/products/veste-chauffante-a-capuche-femme-12.webp",
      "assets/products/veste-chauffante-a-capuche-femme-11.webp",
      "assets/products/veste-chauffante-a-capuche-femme-13.webp",
      "assets/products/veste-chauffante-a-capuche-femme-14.webp"
    ],
    "description": "Une veste qui produit sa propre chaleur, là où vous en avez besoin. Vous l'enfilez comme n'importe quelle veste d'hiver, vous appuyez sur le bouton, et la chaleur se diffuse doucement dans le dos, sur les épaules, à la nuque et au ventre. Pourquoi on l'a choisie 6 zones de chaleur : nuque, épaules, dos et ventre. Les endroits où le froid s'installe en premier. Un seul bouton , sur la poitrine : pas d'application, pas de télécommande. Doublure intérieure réfléchissante qui garde la chaleur contre vous au lieu de la laisser s'échapper. Tissu coupe-vent et imperméable , avec capuche et col montant, pour sortir sans appréhension. Chaude même éteinte : c'est d'abord une vraie veste matelassée d'hiver. Comment ça marche La veste fonctionne en basse tension, avec une batterie externe USB (non incluse) qui se branche à l'intérieur. Un appui sur le bouton suffit pour l'allumer et régler la chaleur. Composition Tissu extérieur : 100 % polyester Rembourrage : coton Doublure : polyester, avec film réfléchissant Fermeture éclair, capuche, col montant, poches Coupe homme, du S au XXL Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Une veste qui produit sa propre chaleur, là où vous en avez besoin.</strong> Vous l'enfilez comme n'importe quelle veste d'hiver, vous appuyez sur le bouton, et la chaleur se diffuse doucement dans le dos, sur les épaules, à la nuque et au ventre.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>6 zones de chaleur</strong> : nuque, épaules, dos et ventre. Les endroits où le froid s'installe en premier.</li>\n<li>\n<strong>Un seul bouton</strong>, sur la poitrine : pas d'application, pas de télécommande.</li>\n<li>\n<strong>Doublure intérieure réfléchissante</strong> qui garde la chaleur contre vous au lieu de la laisser s'échapper.</li>\n<li>\n<strong>Tissu coupe-vent et imperméable</strong>, avec capuche et col montant, pour sortir sans appréhension.</li>\n<li>\n<strong>Chaude même éteinte</strong> : c'est d'abord une vraie veste matelassée d'hiver.</li>\n</ul>\n<h3>Comment ça marche</h3>\n<p>La veste fonctionne en basse tension, avec une batterie externe USB (non incluse) qui se branche à l'intérieur. Un appui sur le bouton suffit pour l'allumer et régler la chaleur.</p>\n<h3>Composition</h3>\n<ul>\n<li>Tissu extérieur : 100 % polyester</li>\n<li>Rembourrage : coton</li>\n<li>Doublure : polyester, avec film réfléchissant</li>\n<li>Fermeture éclair, capuche, col montant, poches</li>\n<li>Coupe homme, du S au XXL</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "6 zones de chaleur : nuque, épaules, dos et ventre. Les endroits où le froid s'installe en premier.",
      "Un seul bouton , sur la poitrine : pas d'application, pas de télécommande.",
      "Doublure intérieure réfléchissante qui garde la chaleur contre vous au lieu de la laisser s'échapper.",
      "Tissu coupe-vent et imperméable , avec capuche et col montant, pour sortir sans appréhension.",
      "Chaude même éteinte : c'est d'abord une vraie veste matelassée d'hiver.",
      "Tissu extérieur : 100 % polyester",
      "Rembourrage : coton",
      "Doublure : polyester, avec film réfléchissant",
      "Fermeture éclair, capuche, col montant, poches",
      "Coupe homme, du S au XXL"
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL"
    ],
    "colors": [
      "Noir",
      "Bleu marine",
      "Rouge"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Bleu marine",
          "Rouge"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "S",
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55388871426385,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-S",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871459153,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871491921,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871524689,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871557457,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871590225,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871622993,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-NR-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-homme-01.webp"
      },
      {
        "id": 55388871655761,
        "title": "Bleu marine / S",
        "option1": "Bleu marine",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-S",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871688529,
        "title": "Bleu marine / M",
        "option1": "Bleu marine",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871721297,
        "title": "Bleu marine / L",
        "option1": "Bleu marine",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871754065,
        "title": "Bleu marine / XL",
        "option1": "Bleu marine",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871786833,
        "title": "Bleu marine / XXL",
        "option1": "Bleu marine",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871819601,
        "title": "Bleu marine / 3XL",
        "option1": "Bleu marine",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871852369,
        "title": "Bleu marine / 4XL",
        "option1": "Bleu marine",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-BM-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-11.webp"
      },
      {
        "id": 55388871885137,
        "title": "Rouge / S",
        "option1": "Rouge",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-S",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388871917905,
        "title": "Rouge / M",
        "option1": "Rouge",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-M",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388871950673,
        "title": "Rouge / L",
        "option1": "Rouge",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-L",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388871983441,
        "title": "Rouge / XL",
        "option1": "Rouge",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872016209,
        "title": "Rouge / XXL",
        "option1": "Rouge",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-XXL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872048977,
        "title": "Rouge / 3XL",
        "option1": "Rouge",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-3XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      },
      {
        "id": 55388872081745,
        "title": "Rouge / 4XL",
        "option1": "Rouge",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-VC11-RG-4XL",
        "price": 144.0,
        "compareAtPrice": 180.0,
        "image": "assets/products/veste-chauffante-a-capuche-femme-12.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11203915284817,
    "handle": "gilet-chauffant-homme-temperature-reglable",
    "title": "Gilet chauffant homme",
    "url": "https://chaleursereine.com/products/gilet-chauffant-homme-temperature-reglable",
    "price": 99.9,
    "compareAtPrice": 119.9,
    "available": true,
    "category": "Gilet chauffant",
    "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp",
    "images": [
      "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-02.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-03.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-04.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-05.webp",
      "assets/products/veste-chauffante-a-capuche-femme-08.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-07.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-08.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-09.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-10.webp",
      "assets/products/gilet-chauffant-homme-temperature-reglable-11.webp"
    ],
    "description": "Un gilet qui chauffe, pour garder le dos au chaud toute la journée. Glissé sous une veste ou porté seul, il diffuse une chaleur réglable dès qu'il est branché à sa batterie. Pour le jardin, la promenade, les trajets du matin ou une maison qu'on ne veut pas surchauffer. Pourquoi on l'a choisi Température réglable : vous choisissez la chaleur qui vous convient. Batterie non incluse : elle se glisse dans la poche, sans fil apparent. Coupe courte et sans manches : rien ne gêne les mouvements. Garnissage coton : il tient chaud même éteint. Coupe homme, du S au XXL. Composition Tissu : polyester et coton Garnissage : coton Col rond, coupe courte Coloris : noir Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Un gilet qui chauffe, pour garder le dos au chaud toute la journée.</strong> Glissé sous une veste ou porté seul, il diffuse une chaleur réglable dès qu'il est branché à sa batterie. Pour le jardin, la promenade, les trajets du matin ou une maison qu'on ne veut pas surchauffer.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>Température réglable</strong> : vous choisissez la chaleur qui vous convient.</li>\n<li>\n<strong>Batterie non incluse</strong> : elle se glisse dans la poche, sans fil apparent.</li>\n<li>\n<strong>Coupe courte et sans manches</strong> : rien ne gêne les mouvements.</li>\n<li>\n<strong>Garnissage coton</strong> : il tient chaud même éteint.</li>\n<li><strong>Coupe homme, du S au XXL.</strong></li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Tissu : polyester et coton</li>\n<li>Garnissage : coton</li>\n<li>Col rond, coupe courte</li>\n<li>Coloris : noir</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "Température réglable : vous choisissez la chaleur qui vous convient.",
      "Batterie non incluse : elle se glisse dans la poche, sans fil apparent.",
      "Coupe courte et sans manches : rien ne gêne les mouvements.",
      "Garnissage coton : il tient chaud même éteint.",
      "Coupe homme, du S au XXL.",
      "Tissu : polyester et coton",
      "Garnissage : coton",
      "Col rond, coupe courte",
      "Coloris : noir"
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL",
      "3XL",
      "4XL"
    ],
    "colors": [
      "Noir"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "S",
          "M",
          "L",
          "XL",
          "XXL",
          "3XL",
          "4XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55153428529489,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-S",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      },
      {
        "id": 55153428562257,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-M",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      },
      {
        "id": 55153428595025,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-L",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      },
      {
        "id": 55153428627793,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-XL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      },
      {
        "id": 55153428660561,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-XXL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      },
      {
        "id": 55153428693329,
        "title": "Noir / 3XL",
        "option1": "Noir",
        "option2": "3XL",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-3XL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      },
      {
        "id": 55153428726097,
        "title": "Noir / 4XL",
        "option1": "Noir",
        "option2": "4XL",
        "option3": null,
        "available": true,
        "sku": "CS-GH-NR-4XL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-homme-temperature-reglable-01.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11203915055441,
    "handle": "gilet-chauffant-femme-9-zones",
    "title": "Gilet chauffant femme",
    "url": "https://chaleursereine.com/products/gilet-chauffant-femme-9-zones",
    "price": 99.9,
    "compareAtPrice": 119.9,
    "available": true,
    "category": "Gilet chauffant",
    "image": "assets/products/gilet-chauffant-femme-9-zones-01.webp",
    "images": [
      "assets/products/gilet-chauffant-femme-9-zones-01.webp",
      "assets/products/gilet-chauffant-femme-9-zones-02.webp",
      "assets/products/gilet-chauffant-femme-9-zones-03.webp",
      "assets/products/gilet-chauffant-femme-9-zones-04.webp",
      "assets/products/gilet-chauffant-femme-9-zones-05.webp",
      "assets/products/gilet-chauffant-femme-9-zones-06.webp",
      "assets/products/gilet-chauffant-femme-9-zones-07.webp",
      "assets/products/gilet-chauffant-femme-9-zones-08.webp",
      "assets/products/veste-chauffante-a-capuche-femme-08.webp",
      "assets/products/gilet-chauffant-femme-9-zones-10.webp",
      "assets/products/gilet-chauffant-femme-9-zones-11.webp",
      "assets/products/gilet-chauffant-femme-9-zones-12.webp",
      "assets/products/gilet-chauffant-femme-9-zones-13.webp",
      "assets/products/gilet-chauffant-femme-9-zones-14.webp",
      "assets/products/gilet-chauffant-femme-9-zones-15.webp"
    ],
    "description": "La chaleur au cœur du corps, sans l'épaisseur d'un manteau. Ce gilet chauffant se porte sous une veste, sur un pull ou seul à la maison. Branchez-le à une batterie USB : la chaleur se diffuse dans le dos et sur le buste, là où le froid s'installe en premier. Pourquoi on l'a choisi 9 zones chauffantes , réparties sur le dos et le buste. Sans manches : les bras restent libres, il se glisse sous n'importe quel manteau. Col montant pour protéger la nuque, fermeture éclair. Coupe-vent , et ouaté : il tient chaud même éteint. Du S au XXL , en noir, bleu ou rouge. Composition Tissu extérieur : 100 % polyester Garnissage : ouate Col montant, fermeture éclair Alimentation : batterie USB 5 V (non incluse) Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>La chaleur au cœur du corps, sans l'épaisseur d'un manteau.</strong> Ce gilet chauffant se porte sous une veste, sur un pull ou seul à la maison. Branchez-le à une batterie USB : la chaleur se diffuse dans le dos et sur le buste, là où le froid s'installe en premier.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>9 zones chauffantes</strong>, réparties sur le dos et le buste.</li>\n<li>\n<strong>Sans manches</strong> : les bras restent libres, il se glisse sous n'importe quel manteau.</li>\n<li>\n<strong>Col montant</strong> pour protéger la nuque, fermeture éclair.</li>\n<li>\n<strong>Coupe-vent</strong>, et ouaté : il tient chaud même éteint.</li>\n<li>\n<strong>Du S au XXL</strong>, en noir, bleu ou rouge.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Tissu extérieur : 100 % polyester</li>\n<li>Garnissage : ouate</li>\n<li>Col montant, fermeture éclair</li>\n<li>Alimentation : batterie USB 5 V (non incluse)</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "9 zones chauffantes , réparties sur le dos et le buste.",
      "Sans manches : les bras restent libres, il se glisse sous n'importe quel manteau.",
      "Col montant pour protéger la nuque, fermeture éclair.",
      "Coupe-vent , et ouaté : il tient chaud même éteint.",
      "Du S au XXL , en noir, bleu ou rouge.",
      "Tissu extérieur : 100 % polyester",
      "Garnissage : ouate",
      "Col montant, fermeture éclair",
      "Alimentation : batterie USB 5 V (non incluse)"
    ],
    "sizes": [
      "S",
      "M",
      "L",
      "XL",
      "XXL"
    ],
    "colors": [
      "Noir",
      "Bleu",
      "Rouge"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Bleu",
          "Rouge"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "S",
          "M",
          "L",
          "XL",
          "XXL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55153426760017,
        "title": "Noir / S",
        "option1": "Noir",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-NR-S",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-01.webp"
      },
      {
        "id": 55153426792785,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-NR-M",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-01.webp"
      },
      {
        "id": 55153426825553,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-NR-L",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-01.webp"
      },
      {
        "id": 55153426858321,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-NR-XL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-01.webp"
      },
      {
        "id": 55153426891089,
        "title": "Noir / XXL",
        "option1": "Noir",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-NR-XXL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-01.webp"
      },
      {
        "id": 55350763979089,
        "title": "Bleu / S",
        "option1": "Bleu",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-BL-S",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-12.webp"
      },
      {
        "id": 55350764011857,
        "title": "Bleu / M",
        "option1": "Bleu",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-BL-M",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-12.webp"
      },
      {
        "id": 55350764044625,
        "title": "Bleu / L",
        "option1": "Bleu",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-BL-L",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-12.webp"
      },
      {
        "id": 55350764077393,
        "title": "Bleu / XL",
        "option1": "Bleu",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-BL-XL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-12.webp"
      },
      {
        "id": 55350764110161,
        "title": "Bleu / XXL",
        "option1": "Bleu",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-BL-XXL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-12.webp"
      },
      {
        "id": 55350764274001,
        "title": "Rouge / S",
        "option1": "Rouge",
        "option2": "S",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-RG-S",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-13.webp"
      },
      {
        "id": 55350764306769,
        "title": "Rouge / M",
        "option1": "Rouge",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-RG-M",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-13.webp"
      },
      {
        "id": 55350764339537,
        "title": "Rouge / L",
        "option1": "Rouge",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-RG-L",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-13.webp"
      },
      {
        "id": 55350764372305,
        "title": "Rouge / XL",
        "option1": "Rouge",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-RG-XL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-13.webp"
      },
      {
        "id": 55350764405073,
        "title": "Rouge / XXL",
        "option1": "Rouge",
        "option2": "XXL",
        "option3": null,
        "available": true,
        "sku": "CS-GF9-RG-XXL",
        "price": 99.9,
        "compareAtPrice": 119.9,
        "image": "assets/products/gilet-chauffant-femme-9-zones-13.webp"
      }
    ],
    "batteryNote": "Batterie USB non incluse, vendue séparément."
  },
  {
    "id": 11203877273937,
    "handle": "batterie-externe-10000-mah",
    "title": "Batterie externe 10 000 mAh – pour vêtements chauffants USB",
    "url": "https://chaleursereine.com/products/batterie-externe-10000-mah",
    "price": 35.0,
    "compareAtPrice": null,
    "available": true,
    "category": "Batterie",
    "image": "assets/products/batterie-externe-10000-mah-01.webp",
    "images": [
      "assets/products/batterie-externe-10000-mah-01.webp",
      "assets/products/ensemble-sous-couche-chauffant-femme-10.webp",
      "assets/products/batterie-externe-10000-mah-03.webp",
      "assets/products/batterie-externe-10000-mah-04.webp"
    ],
    "description": "Une batterie de plus, c'est une sortie qui dure plus longtemps. Cette batterie externe de 10 000 mAh alimente les vêtements chauffants à connexion USB, et recharge aussi votre téléphone. Glissez-la dans la poche prévue à cet effet, et la chaleur vous accompagne. Pourquoi on l'a choisie 10 000 mAh : de quoi tenir une longue sortie, ou garder une batterie de rechange pour la journée. Compacte et légère : 9 × 6,4 × 2,3 cm pour 85 g, elle se fait oublier dans la poche. Sortie USB 5 V / 2,1 A , compatible avec les vêtements chauffants à connexion USB et avec votre téléphone. Protection contre la surcharge. Caractéristiques Capacité : 10 000 mAh, batterie lithium-polymère Entrée : 5 V (recharge par USB) · Sortie : 5 V / 2,1 A (10 W) Dimensions : 90 × 64 × 23 mm · Poids : 85 g Boîtier : ABS · Coloris : noir ou blanc Vous ne savez pas si elle est compatible avec votre vêtement ? Appelez-nous : une vraie personne vous répond.",
    "descriptionHtml": "<p><strong>Une batterie de plus, c'est une sortie qui dure plus longtemps.</strong> Cette batterie externe de 10 000 mAh alimente les vêtements chauffants à connexion USB, et recharge aussi votre téléphone. Glissez-la dans la poche prévue à cet effet, et la chaleur vous accompagne.</p>\n<h3>Pourquoi on l'a choisie</h3>\n<ul>\n<li>\n<strong>10 000 mAh</strong> : de quoi tenir une longue sortie, ou garder une batterie de rechange pour la journée.</li>\n<li>\n<strong>Compacte et légère</strong> : 9 × 6,4 × 2,3 cm pour 85 g, elle se fait oublier dans la poche.</li>\n<li>\n<strong>Sortie USB 5 V / 2,1 A</strong>, compatible avec les vêtements chauffants à connexion USB et avec votre téléphone.</li>\n<li><strong>Protection contre la surcharge.</strong></li>\n</ul>\n<h3>Caractéristiques</h3>\n<ul>\n<li>Capacité : 10 000 mAh, batterie lithium-polymère</li>\n<li>Entrée : 5 V (recharge par USB) · Sortie : 5 V / 2,1 A (10 W)</li>\n<li>Dimensions : 90 × 64 × 23 mm · Poids : 85 g</li>\n<li>Boîtier : ABS · Coloris : noir ou blanc</li>\n</ul>\n<p>Vous ne savez pas si elle est compatible avec votre vêtement ? Appelez-nous : une vraie personne vous répond.</p>",
    "features": [
      "10 000 mAh : de quoi tenir une longue sortie, ou garder une batterie de rechange pour la journée.",
      "Compacte et légère : 9 × 6,4 × 2,3 cm pour 85 g, elle se fait oublier dans la poche.",
      "Sortie USB 5 V / 2,1 A , compatible avec les vêtements chauffants à connexion USB et avec votre téléphone.",
      "Protection contre la surcharge.",
      "Capacité : 10 000 mAh, batterie lithium-polymère",
      "Entrée : 5 V (recharge par USB) · Sortie : 5 V / 2,1 A (10 W)",
      "Dimensions : 90 × 64 × 23 mm · Poids : 85 g",
      "Boîtier : ABS · Coloris : noir ou blanc"
    ],
    "sizes": [],
    "colors": [
      "Noir",
      "Blanc"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Blanc"
        ]
      }
    ],
    "variants": [
      {
        "id": 55153226645841,
        "title": "Noir",
        "option1": "Noir",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-BAT10K-NR",
        "price": 35.0,
        "compareAtPrice": null,
        "image": "assets/products/batterie-externe-10000-mah-01.webp"
      },
      {
        "id": 55153226678609,
        "title": "Blanc",
        "option1": "Blanc",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-BAT10K-BC",
        "price": 35.0,
        "compareAtPrice": null,
        "image": "assets/products/batterie-externe-10000-mah-01.webp"
      }
    ],
    "batteryNote": "Batterie externe vendue séparément — 10 000 mAh, sortie USB 5 V / 2,1 A."
  },
  {
    "id": 11203849519441,
    "handle": "tour-de-cou-chauffant-rechargeable",
    "title": "Tour de cou chauffant",
    "url": "https://chaleursereine.com/products/tour-de-cou-chauffant-rechargeable",
    "price": 25.0,
    "compareAtPrice": null,
    "available": true,
    "category": "Tour de cou chauffant",
    "image": "assets/products/tour-de-cou-chauffant-rechargeable-01.webp",
    "images": [
      "assets/products/tour-de-cou-chauffant-rechargeable-01.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-02.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-03.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-04.webp",
      "assets/products/veste-chauffante-a-capuche-femme-08.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-06.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-07.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-08.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-09.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-10.webp",
      "assets/products/tour-de-cou-chauffant-rechargeable-11.webp"
    ],
    "description": "La nuque, c'est par là que le froid s'installe. Ce tour de cou chauffant se glisse autour du cou comme une écharpe, et diffuse une chaleur douce grâce à sa batterie rechargeable. Idéal pour la promenade, l'attente du bus ou le marché du dimanche. Pourquoi on l'a choisi Chaleur sur la nuque , la zone qui refroidit tout le corps quand elle est exposée. Batterie rechargeable : pas de piles à racheter. Léger : il se porte seul ou sous un manteau, sans gêner. Unisexe et taille unique (80 × 10 cm), en 9 coloris. Le petit cadeau qui fait plaisir , à offrir ou à s'offrir. Composition Matière : 100 % polyester Dimensions : 80 × 10 cm Coloris : noir, blanc, gris, marron, bleu marine, rouge, rose Une question avant de commander ? Appelez-nous : une vraie personne vous répond.",
    "descriptionHtml": "<p><strong>La nuque, c'est par là que le froid s'installe.</strong> Ce tour de cou chauffant se glisse autour du cou comme une écharpe, et diffuse une chaleur douce grâce à sa batterie rechargeable. Idéal pour la promenade, l'attente du bus ou le marché du dimanche.</p>\n<h3>Pourquoi on l'a choisi</h3>\n<ul>\n<li>\n<strong>Chaleur sur la nuque</strong>, la zone qui refroidit tout le corps quand elle est exposée.</li>\n<li>\n<strong>Batterie rechargeable</strong> : pas de piles à racheter.</li>\n<li>\n<strong>Léger</strong> : il se porte seul ou sous un manteau, sans gêner.</li>\n<li>\n<strong>Unisexe et taille unique</strong> (80 × 10 cm), en 9 coloris.</li>\n<li>\n<strong>Le petit cadeau qui fait plaisir</strong>, à offrir ou à s'offrir.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Matière : 100 % polyester</li>\n<li>Dimensions : 80 × 10 cm</li>\n<li>Coloris : noir, blanc, gris, marron, bleu marine, rouge, rose </li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond.</p>",
    "features": [
      "Chaleur sur la nuque , la zone qui refroidit tout le corps quand elle est exposée.",
      "Batterie rechargeable : pas de piles à racheter.",
      "Léger : il se porte seul ou sous un manteau, sans gêner.",
      "Unisexe et taille unique (80 × 10 cm), en 9 coloris.",
      "Le petit cadeau qui fait plaisir , à offrir ou à s'offrir.",
      "Matière : 100 % polyester",
      "Dimensions : 80 × 10 cm",
      "Coloris : noir, blanc, gris, marron, bleu marine, rouge, rose"
    ],
    "sizes": [],
    "colors": [
      "Noir",
      "Blanc",
      "Bleu marine",
      "Rouge",
      "Rose",
      "marron",
      "gris"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir",
          "Blanc",
          "Bleu marine",
          "Rouge",
          "Rose",
          "marron",
          "gris"
        ]
      }
    ],
    "variants": [
      {
        "id": 55152907911505,
        "title": "Noir",
        "option1": "Noir",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-TC1-NR",
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-01.webp"
      },
      {
        "id": 55152907944273,
        "title": "Blanc",
        "option1": "Blanc",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-TC1-BC",
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-11.webp"
      },
      {
        "id": 55152908042577,
        "title": "Bleu marine",
        "option1": "Bleu marine",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-TC1-BM",
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-07.webp"
      },
      {
        "id": 55152908075345,
        "title": "Rouge",
        "option1": "Rouge",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-TC1-BCL",
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-09.webp"
      },
      {
        "id": 55152908140881,
        "title": "Rose",
        "option1": "Rose",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": "CS-TC1-RS",
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-08.webp"
      },
      {
        "id": 55323066466641,
        "title": "marron",
        "option1": "marron",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": null,
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-10.webp"
      },
      {
        "id": 55323066499409,
        "title": "gris",
        "option1": "gris",
        "option2": null,
        "option3": null,
        "available": true,
        "sku": null,
        "price": 25.0,
        "compareAtPrice": null,
        "image": "assets/products/tour-de-cou-chauffant-rechargeable-06.webp"
      }
    ],
    "batteryNote": "Batterie rechargeable mentionnée dans la fiche. Contenu exact à confirmer."
  },
  {
    "id": 11203855647057,
    "handle": "gants-chauffants-impermeables",
    "title": "Gants chauffants imperméables",
    "url": "https://chaleursereine.com/products/gants-chauffants-impermeables",
    "price": 48.0,
    "compareAtPrice": 60.0,
    "available": true,
    "category": "Gants chauffants",
    "image": "assets/products/gants-chauffants-impermeables-01.webp",
    "images": [
      "assets/products/gants-chauffants-impermeables-01.webp",
      "assets/products/gants-chauffants-impermeables-02.webp",
      "assets/products/gants-chauffants-impermeables-03.webp",
      "assets/products/gants-chauffants-impermeables-04.webp"
    ],
    "description": "Les mains sont les premières à geler, et les dernières à se réchauffer. Ces gants chauffants produisent leur propre chaleur, avec une température réglable selon le froid du jour. Pour la promenade du matin, le ski, le vélo ou simplement pour attendre au froid sans avoir les doigts engourdis. Pourquoi on les a choisis Température réglable : vous choisissez la chaleur qui vous convient. Imperméables : neige, pluie ou bruine, vos mains restent au sec. Chauds même éteints : ce sont d'abord de vrais gants d'hiver. Unisexes , du M au XL. Le cadeau idéal pour ceux qui ont toujours les mains froides. Composition Matière : coton et élasthanne Fermeture : à enfiler Coloris : noir Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.",
    "descriptionHtml": "<p><strong>Les mains sont les premières à geler, et les dernières à se réchauffer.</strong> Ces gants chauffants produisent leur propre chaleur, avec une température réglable selon le froid du jour. Pour la promenade du matin, le ski, le vélo ou simplement pour attendre au froid sans avoir les doigts engourdis.</p>\n<h3>Pourquoi on les a choisis</h3>\n<ul>\n<li>\n<strong>Température réglable</strong> : vous choisissez la chaleur qui vous convient.</li>\n<li>\n<strong>Imperméables</strong> : neige, pluie ou bruine, vos mains restent au sec.</li>\n<li>\n<strong>Chauds même éteints</strong> : ce sont d'abord de vrais gants d'hiver.</li>\n<li>\n<strong>Unisexes</strong>, du M au XL.</li>\n<li>\n<strong>Le cadeau idéal</strong> pour ceux qui ont toujours les mains froides.</li>\n</ul>\n<h3>Composition</h3>\n<ul>\n<li>Matière : coton et élasthanne</li>\n<li>Fermeture : à enfiler</li>\n<li>Coloris : noir</li>\n</ul>\n<p>Une question avant de commander ? Appelez-nous : une vraie personne vous répond et vous aide à choisir la bonne taille.</p>",
    "features": [
      "Température réglable : vous choisissez la chaleur qui vous convient.",
      "Imperméables : neige, pluie ou bruine, vos mains restent au sec.",
      "Chauds même éteints : ce sont d'abord de vrais gants d'hiver.",
      "Unisexes , du M au XL.",
      "Le cadeau idéal pour ceux qui ont toujours les mains froides.",
      "Matière : coton et élasthanne",
      "Fermeture : à enfiler",
      "Coloris : noir"
    ],
    "sizes": [
      "M",
      "L",
      "XL"
    ],
    "colors": [
      "Noir"
    ],
    "options": [
      {
        "name": "Couleur",
        "position": 1,
        "values": [
          "Noir"
        ]
      },
      {
        "name": "Taille",
        "position": 2,
        "values": [
          "M",
          "L",
          "XL"
        ]
      }
    ],
    "variants": [
      {
        "id": 55152987046225,
        "title": "Noir / M",
        "option1": "Noir",
        "option2": "M",
        "option3": null,
        "available": true,
        "sku": "CS-GC1-NR-M",
        "price": 48.0,
        "compareAtPrice": 60.0,
        "image": "assets/products/gants-chauffants-impermeables-01.webp"
      },
      {
        "id": 55152987078993,
        "title": "Noir / L",
        "option1": "Noir",
        "option2": "L",
        "option3": null,
        "available": true,
        "sku": "CS-GC1-NR-L",
        "price": 48.0,
        "compareAtPrice": 60.0,
        "image": "assets/products/gants-chauffants-impermeables-01.webp"
      },
      {
        "id": 55152987111761,
        "title": "Noir / XL",
        "option1": "Noir",
        "option2": "XL",
        "option3": null,
        "available": true,
        "sku": "CS-GC1-NR-XL",
        "price": 48.0,
        "compareAtPrice": 60.0,
        "image": "assets/products/gants-chauffants-impermeables-01.webp"
      }
    ],
    "batteryNote": "Alimentation et batterie fournie ou non : non précisées dans la fiche publique."
  }
];
